import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store/store";
import { AuthProvider } from "react-oidc-context";
import { cognitoAuthConfig } from "./cognitoAuthConfig";
import { ClientProvider } from "./utils/client_info";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <Provider store={store}>
      <ClientProvider>
        <App />
      </ClientProvider>
    </Provider>
  </AuthProvider>
);
// React.StrictMode has been removed to avoid double rendering of hooks in development mode.
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
